import { Card, CardContent, Typography, Box, Stack } from '@mui/material';
import { UserLabourGroupAssignment } from '../../UserLabourGroupAssignment';

interface UserLabourGroupCardProps {
  userId: string;
  currentGroupId: number | null | undefined;
  currentGroupName: string | null;
}

export function UserLabourGroupCard({
  userId,
  currentGroupId,
  currentGroupName,
}: UserLabourGroupCardProps) {
  return (
    <Card variant="outlined" data-testid="user-labour-group-card">
      <CardContent>
        <Stack spacing={2}>
          {/* Card Title */}
          <Typography variant="h6" component="h3">
            Labour Group
          </Typography>

          {/* Explanatory Text */}
          <Typography variant="body2" color="text.secondary">
            This group controls what labour items this user can see. Without a
            labour group, they cannot view any labour information.
          </Typography>

          {/* Assignment Component */}
          <Box>
            <UserLabourGroupAssignment
              userId={userId}
              currentGroupId={currentGroupId}
              currentGroupName={currentGroupName}
            />
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
}
